var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14C12.207 16.3795 13 27 13 27C13 27 13.793 16.3795 24.5 14C13.793 11.6205 13 1 13 1C13 1 12.207 11.6205 1.5 14ZM17.5 24C19.1865 24.3251 20.7256 25.1788 21.8943 26.4374C23.063 27.696 23.8006 29.2941 24 31C24.1994 29.2941 24.937 27.696 26.1057 26.4374C27.2744 25.1788 28.8135 24.3251 30.5 24C28.8135 23.6749 27.2744 22.8212 26.1057 21.5626C24.937 20.304 24.1994 18.7059 24 17C23.8006 18.7059 23.063 20.304 21.8943 21.5626C20.7256 22.8212 19.1865 23.6749 17.5 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistActive);
export default __webpack_public_path__ + "static/media/AI Assist-Active.667be6aea4b0d7dac2a7a6cf7006cc45.svg";
export { ForwardRef as ReactComponent };